module.exports = {
          srcSet: __webpack_public_path__ + "a3cf91325ef04e218ed4f2ae3a5fc432-360.png"+" 360w",
          images:[ {path: __webpack_public_path__ + "a3cf91325ef04e218ed4f2ae3a5fc432-360.png",width: 360,height: 476}],
          src: __webpack_public_path__ + "a3cf91325ef04e218ed4f2ae3a5fc432-360.png",
          toString:function(){return __webpack_public_path__ + "a3cf91325ef04e218ed4f2ae3a5fc432-360.png"},
          
          width: 360,
          height: 476
        }